<template>
  <NuxtPage />
  <Loading />
</template>

<script setup>
  // Defaultno trajanje tranzicije je 250ms, može se promjeniti u composableu useSetup
  const { get, isWebsiteInited } = usePage()
  try {
    const { init } = useSetup()
    const { setLanguage } = useLanguage()
    
    await setLanguage()
    await init()
  } catch (e) {
    console.dir(e)
    throw createError({
      statusCode: 500,
      statusMessage: 'Failed to get setup script'
    })
  }

  onMounted(() => {
    document.documentElement.style.setProperty('--vh', `${document.documentElement.clientHeight}px`);
  })

  /*if(import.meta.client) {
    const { lang } = useLanguage()
    useHead({
      script: [
        {
          id: 'Cookiebot',
          src: 'https://consent.cookiebot.com/uc.js',
          'data-cbid': 'b924546c-0804-4502-ac18-54930b2c00c1',
          'data-consentmode': 'disabled',
          'data-culture': lang,
          rel: 'preconnect',
        }
      ],
    })
  }*/

  await get()
  useNuxtApp().hook('page:finish', () => {
    if (!isWebsiteInited.value) isWebsiteInited.value = true
  })

  useNuxtApp().hook('auth:aminess:logout', () => {
    const { links, link } = useSetup()
    const { path } = useRouter().currentRoute.value
    if ([links.value['LoyaltyDashboard'], links.value['LoyaltyFAQ'], links.value['Points'], links.value['Profile'], links.value['Stays'], links.value['StaysDetail']].includes(path)) {
      window.location.href = link('Login');
    }
  })

  useNuxtApp().hook('auth:local:logout', () => {
    const { link } = useSetup()
    window.location.href = link('MediaAlbumLogin');
  })
</script>
